import FileService from '@/api/services/file.service';
import {
  DISH_PHOTO_LONG_EDGE,
  DISH_PHOTO_UPLOAD_NAME,
} from '@/domain/menu-import/item-editor';
import { processImage } from '@/lib/menu-capture/image-processor';

/** A dish photo upload gives up after this long without an answer. */
export const DISH_PHOTO_UPLOAD_TIMEOUT_MS = 60000;

/**
 * A picked dish photo, resized in the browser (≤ 1600 px, JPEG) and
 * uploaded; returns its `temp/…` path for the product's `picture`. Throws
 * `ImageUnreadableError` for files the browser cannot read.
 */
export async function uploadMenuPhoto(file: File): Promise<string> {
  const { blob } = await processImage(file, DISH_PHOTO_LONG_EDGE);
  const entity = await FileService.upload(
    new File([blob], DISH_PHOTO_UPLOAD_NAME, { type: 'image/jpeg' }),
    DISH_PHOTO_UPLOAD_TIMEOUT_MS
  );
  return entity.path;
}
